/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingtypestoryhint3Inputs */

const en_crosspostingtypestoryhint3 = /** @type {(inputs: Crosspostingtypestoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single image per platform.`)
};

const de_crosspostingtypestoryhint3 = /** @type {(inputs: Crosspostingtypestoryhint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein einzelnes Bild pro Plattform.`)
};

/**
* | output |
* | --- |
* | "A single image per platform." |
*
* @param {Crosspostingtypestoryhint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingtypestoryhint3 = /** @type {((inputs?: Crosspostingtypestoryhint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingtypestoryhint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingtypestoryhint3(inputs)
	return de_crosspostingtypestoryhint3(inputs)
});
export { crosspostingtypestoryhint3 as "crosspostingTypeStoryHint" }